
<template>
  <p class="mt-3">
    <v-alert
      colored-border
      border="left"
      elevation="2"
      :color="color"
      :icon="icon"
    >
      <template>
        <slot name="content" />
      </template>
    </v-alert>
  </p>
</template>

<script>

export default {
  name: 'NajAlert',
  components: {},
  props: {
    // color: {
    //   type: String,
    //   default: '#faad14',
    // },
    // icon: {
    //   type: String,
    //   default: 'mdi-alert-circle-outline',
    // },
    type: {
      type: String,
      default: 'alert',
    },
  },
  data() {
    return {};
  },
  computed: {
    color() {
      if (this.type == 'alert')
        return '#faad14';
      else if (this.type == 'information')
        return 'var(--app-info-color)';
      else if (this.type == 'error')
        return '#EC6A4F';
      else if (this.type == 'success')
        return '#4AAA6E';
      return '#faad14';
    },
    icon() {
      if (this.type == 'alert')
        return 'mdi-alert-circle-outline';
      else if (this.type == 'information')
        return 'mdi-information';
      else if (this.type == 'error')
        return 'mdi-alert-circle';
      else if (this.type == 'success')
        return 'mdi-check-circle-outline';
      return 'mdi-alert-circle-outline';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-alert__wrapper {
    padding: 10px 0;
  }
  .v-alert__border {
    border-width: 2px;
  }
  .v-alert__content {
    color: var(--app-dark-primary-color);
  }
  .v-alert__icon.v-icon {
    font-size: 40px;
  }
}
</style>
